import {fetching} from "./index";

import * as routesApi from "../constants/api"

export function versionGetAction() {
    return fetching("VERSION", routesApi.version.version + '?time=' + (new Date()).getTime());
}